export default __webpack_public_path__ + "static/texture-bottom-1a582e34b2c0cd519b8c98cad1d9e655.jpeg";